import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import { TeacherModel, TeacherQuery } from "@/types/teacher.model";
import { removeEmptyProps } from "@/utils/constants";
import moment from "moment";

interface CreateTeacherResponse {
  id: string;
  login_user: string;
  login_email: string;
  token: string;
  is_email_sent: boolean;
}

interface UpdateTeacherResponse {
  id: string;
  login_user: string;
  login_email: string;
}

export const getAllTeacherService = async (query: TeacherQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<TeacherModel[]>>("/tch/api/v1/list", {
    params: removeEmptyProps(query),
  });
};

export const createTeacherService = async (payload: TeacherModel) => {
  return AXIOS.post<APIResponse<CreateTeacherResponse>>(
    "/tch/api/v1/add",
    payload
  );
};

export const updateTeacherService = async (
  id: string,
  payload: TeacherModel
) => {
  return AXIOS.patch<APIResponse<UpdateTeacherResponse>>(
    `/tch/api/v1/update/${id}`,
    payload
  );
};

export const deleteTeacherService = async (id: string) => {
  return AXIOS.delete<{ message: string }>(`/tch/api/v1/delete/${id}`);
};

export const getTeacherService = async (id: string) => {
  return AXIOS.get<APIResponse<TeacherModel>>(`/tch/api/v1/view/${id}`);
};

export const downloadTeacherService = async (
  type: "pdf" | "xl" | "csv",
  params: TeacherQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<{ message: string }>(`/tch/api/v1/dwnld/${type}`, {
    params: removeEmptyProps(params),
    responseType: "blob",
  });
};

/**
 * Get teachers for dropdown selection
 */
export const getTeachersDropdownService = async (query: { search: string }) => {
  return AXIOS.get<APIResponse<{ id: string; name: string }[]>>(
    "/tch/api/v1/dropdown",
    {
      params: query,
    }
  );
};

export const assignStudentService = async (payload: {
  tch_id: string;
  student_ids: string[];
  grade_id: string[];
}) => {
  return AXIOS.post<APIResponse<{ message: string }>>(
    `/tch/api/v1/assign`,
    payload
  );
};

export const assignClassToStudentsService = async (payload: {
  tch_id: string;
  class_ids: string[];
  student_ids: string[];
  schoolId: string;
}) => {
  return AXIOS.post<APIResponse<Record<string, unknown>>>(
    "/class/api/v1/assign",
    payload
  );
};
